// src/jira/playbook/types.ts
var JiraPlaybookAriResourceOwner = "jira", JiraPlaybookAriResourceType = "playbook";

export {
  JiraPlaybookAriResourceOwner,
  JiraPlaybookAriResourceType
};
